'use client';

import { useSearchParams } from '@framework/next/navigation';
import { useEmRegionFilters } from '@/creditflowresearch/application/PageFilters/hooks/useEmRegionFilters';
import type { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { transformToFilterSets } from './helpers/transformToFilterSets';

export const useEmStatsFilters = (): IFilterSet[] => {
  const searchParams = useSearchParams();
  const regions = useEmRegionFilters();

  return transformToFilterSets([
    { key: 'regions', items: regions },
  ], { regions: searchParams.get('regions') });
};
